/**
 * channelLookups.js - Build slug/_id lookup maps from loaded categories.
 *
 * Shared by useArloRecommendations (rails content_id resolution) and the
 * Part-A chat hook (pick resolution).
 */
export const buildChannelLookups = categories => {
  const bySlug = new Map();
  const byId = new Map();

  (categories || []).forEach(category => {
    if (!Array.isArray(category.channels)) {return;}
    category.channels.forEach(channel => {
      if (channel.slug) {bySlug.set(channel.slug, channel);}
      if (channel._id) {byId.set(channel._id, channel);}
    });
  });

  return { bySlug, byId };
};
